
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { SetUsername } from '@/api/user'

@Component
export default class EditUserInfoDialog extends Vue {
  @Prop({ default: false }) public visible!: boolean

  public dialogVisible = false
  public loading = false
  public formData = {
    username: ''
  }

  // 响应式布局属性
  get dialogWidth() {
    return window.innerWidth < 768 ? '95%' : '30%'
  }

  get formLabelWidth() {
    return window.innerWidth < 768 ? '80px' : '80px'
  }

  public rules = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
      { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
    ]
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.dialogVisible = val
    if (val) {
      this.resetForm()
    }
  }

  @Watch('dialogVisible')
  onDialogVisibleChange(val: boolean) {
    if (!val) {
      this.$emit('input', false)
    }
  }

  public resetForm() {
    if (UserModule.userInfo) {
      this.formData.username = UserModule.userInfo.username || ''
    }
    // 重置表单验证
    if (this.$refs.form) {
      (this.$refs.form as any).resetFields()
    }
  }

  public async handleSubmit() {
    try {
      const valid = await (this.$refs.form as any).validate()
      if (!valid) return

      this.loading = true
      await SetUsername({ username: this.formData.username })
      this.$message.success('用户名修改成功')
      this.$emit('success')
      this.dialogVisible = false
    } catch (error) {
      console.error('修改用户名失败:', error)
      this.$message.error('修改用户名失败，请重试')
    } finally {
      this.loading = false
    }
  }
}
